import React, {FC} from 'react'
import classnames from 'classnames'

interface Props {
  className?: string
}

export const MicrosoftLogo: FC<Props> = ({className}) => {
  const microsoftClassname = classnames('microsoft-logo', className)
  return (
    <svg
      className={microsoftClassname}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <title>Microsoft icon</title>
      <path
        d="M8.01086e-05 0.124023C8.01086e-05 3.63232 8.01086e-05 7.13315 8.01086e-05 10.6377C3.50881 10.6377 7.01382 10.6377 10.5244 10.6377C10.5244 7.13502 10.5244 3.63232 10.5244 0.124023C7.01941 0.124023 3.5144 0.124023 8.01086e-05 0.124023Z"
        fill="#81BD42"
      />
      <path
        d="M21.9944 11.6096C18.4894 11.6096 14.9974 11.6096 11.4962 11.6096C11.4962 15.1123 11.4962 18.6094 11.4962 22.1177C11.5297 22.1196 11.5613 22.1215 11.5949 22.1215C15.0272 22.1215 18.4596 22.1215 21.892 22.1233C21.9777 22.1233 22 22.0991 22 22.0133C21.9981 18.5796 21.9981 15.144 21.9981 11.7103C21.9981 11.6805 21.9963 11.6488 21.9944 11.6096Z"
        fill="#36A2DB"
      />
      <path
        d="M10.5244 11.6096C7.02313 11.6096 3.52558 11.6096 0.0205688 11.6096C0.0205688 15.1123 0.0205688 18.6132 0.0205688 22.1233C3.51813 22.1233 7.01755 22.1233 10.5244 22.1233C10.5244 18.6225 10.5244 15.1216 10.5244 11.6096Z"
        fill="#FDB915"
      />
      <path
        d="M11.4962 10.6377C14.9993 10.6377 18.4969 10.6377 22 10.6377C22 7.13315 22 3.63232 22 0.124023C18.5006 0.124023 15.0012 0.124023 11.4962 0.124023C11.4962 3.62672 11.4962 7.12756 11.4962 10.6377Z"
        fill="#F15628"
      />
    </svg>
  )
}
